import { TuiNavigation } from '@taiga-ui/layout';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { WINDOW } from '@shared/providers/window.provider';
import { HeroSectionComponent } from './components/hero-section/hero-section.component';
import { MainPageNavbarComponent } from '../../components/main-page-navbar/main-page-navbar.component';
import { PageService } from '../../services/page.service';

@Component({
  selector: 'app-main-page',
  imports: [HeroSectionComponent, MainPageNavbarComponent, TuiNavigation],
  providers: [PageService],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainPageComponent implements OnInit {
  constructor(@Inject(WINDOW) private readonly window: Window) {}

  ngOnInit(): void {
    this.window.scrollTo(0, 0);
  }
}
